<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17888_163066)">
      <path
        d="M1.33203 11.9987C1.33203 10.9717 1.33203 10.4583 1.56318 10.0811C1.69253 9.86999 1.86999 9.69253 2.08105 9.56318C2.45826 9.33203 2.97174 9.33203 3.9987 9.33203C5.02566 9.33203 5.53914 9.33203 5.91634 9.56318C6.12741 9.69253 6.30487 9.86999 6.43421 10.0811C6.66536 10.4583 6.66536 10.9717 6.66536 11.9987C6.66536 13.0257 6.66536 13.5391 6.43421 13.9163C6.30487 14.1274 6.12741 14.3049 5.91634 14.4342C5.53914 14.6654 5.02566 14.6654 3.9987 14.6654C2.97174 14.6654 2.45826 14.6654 2.08105 14.4342C1.86999 14.3049 1.69253 14.1274 1.56318 13.9163C1.33203 13.5391 1.33203 13.0257 1.33203 11.9987Z"
        stroke="currentcolor"
      />
      <path
        d="M9.33203 11.9987C9.33203 10.9717 9.33203 10.4583 9.56318 10.0811C9.69253 9.86999 9.86999 9.69253 10.0811 9.56318C10.4583 9.33203 10.9717 9.33203 11.9987 9.33203C13.0257 9.33203 13.5391 9.33203 13.9163 9.56318C14.1274 9.69253 14.3049 9.86999 14.4342 10.0811C14.6654 10.4583 14.6654 10.9717 14.6654 11.9987C14.6654 13.0257 14.6654 13.5391 14.4342 13.9163C14.3049 14.1274 14.1274 14.3049 13.9163 14.4342C13.5391 14.6654 13.0257 14.6654 11.9987 14.6654C10.9717 14.6654 10.4583 14.6654 10.0811 14.4342C9.86999 14.3049 9.69253 14.1274 9.56318 13.9163C9.33203 13.5391 9.33203 13.0257 9.33203 11.9987Z"
        stroke="currentcolor"
      />
      <path
        d="M1.33203 3.9987C1.33203 2.97174 1.33203 2.45826 1.56318 2.08105C1.69253 1.86999 1.86999 1.69253 2.08105 1.56318C2.45826 1.33203 2.97174 1.33203 3.9987 1.33203C5.02566 1.33203 5.53914 1.33203 5.91634 1.56318C6.12741 1.69253 6.30487 1.86999 6.43421 2.08105C6.66536 2.45826 6.66536 2.97174 6.66536 3.9987C6.66536 5.02566 6.66536 5.53914 6.43421 5.91634C6.30487 6.12741 6.12741 6.30487 5.91634 6.43421C5.53914 6.66536 5.02566 6.66536 3.9987 6.66536C2.97174 6.66536 2.45826 6.66536 2.08105 6.43421C1.86999 6.30487 1.69253 6.12741 1.56318 5.91634C1.33203 5.53914 1.33203 5.02566 1.33203 3.9987Z"
        stroke="currentcolor"
      />
      <path
        d="M9.33203 3.9987C9.33203 2.97174 9.33203 2.45826 9.56318 2.08105C9.69253 1.86999 9.86999 1.69253 10.0811 1.56318C10.4583 1.33203 10.9717 1.33203 11.9987 1.33203C13.0257 1.33203 13.5391 1.33203 13.9163 1.56318C14.1274 1.69253 14.3049 1.86999 14.4342 2.08105C14.6654 2.45826 14.6654 2.97174 14.6654 3.9987C14.6654 5.02566 14.6654 5.53914 14.4342 5.91634C14.3049 6.12741 14.1274 6.30487 13.9163 6.43421C13.5391 6.66536 13.0257 6.66536 11.9987 6.66536C10.9717 6.66536 10.4583 6.66536 10.0811 6.43421C9.86999 6.30487 9.69253 6.12741 9.56318 5.91634C9.33203 5.53914 9.33203 5.02566 9.33203 3.9987Z"
        stroke="currentcolor"
      />
    </g>
    <defs>
      <clipPath id="clip0_17888_163066">
        <rect
          fill="white"
          height="16"
          width="16"
        />
      </clipPath>
    </defs>
  </svg>
</template>
